import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, } from 'react-bootstrap';
import PositionForm from '../components/forms/PositionForm';
import '../styles/EmployeeMaster.css';
import PositionTable from '../components/PositionTable';

const PositionModel = () => {
     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/position/add';

     const handleAddClick = () => {
          navigate('/position/add');
     };

     const handleCloseModal = () => {
          navigate('/position');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Position Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Position
                    </button>
               </div>

               <PositionTable />

               <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    size="md"
                    centered
               >
                    <Modal.Header closeButton>
                         <Modal.Title>Add New Position</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <PositionForm />
                    </Modal.Body>

               </Modal>
          </div>
     );
};

export default PositionModel;
